import CoachingPage from '../../js/pages/CoachingPage';
import {isAdmin} from '../../../server/services/users';
import {getPublicCoachingData} from '../../../server/services/coaching';
import {getTag, getTags} from '../../../server/services/tags';
import {getRecommendedCoaches} from '../../../server/services/recommendations/coaches';
import {getCourseCard} from '../../../server/services/cms';
import UserProfile from '../../../server/models/user_profile';
import {cleanCoaches} from '../../js/util';

import {CoachAvailableStatuses, CoachAvailableStatusesAdmin, RoleCourseMap} from '../../../lib/constants/coaching';

export default CoachingPage;

export async function getServerSideProps({req, query}) {
  // Repeated ?role= params arrive as arrays; use the first
  const roleParam = Array.isArray(query.role) ? query.role[0] : query.role;

  // Role filters with a dedicated landing page (/coaching/pm) canonicalize there
  const roleTag = roleParam ? await getTag(roleParam) : null;
  const rolePathExists = roleTag?.type === 'role';

  let statuses = CoachAvailableStatuses;
  let recommendedCoaches = [];

  if (req.user) {
    const profile = await UserProfile.get(req.user.id);
    const roles = profile.career_tracks || [];
    const companies = profile.interview_companies || [];

    recommendedCoaches = (await getRecommendedCoaches(roles, companies))
      ?.map((coach) => coach.slug);

    if (isAdmin(req.user)) statuses = CoachAvailableStatusesAdmin;
  }

  const [coachingData, tagsData, course] = await Promise.all([
    getPublicCoachingData(statuses),
    getTags(),
    // Shallow-routed role changes won't refetch, so the card is keyed to this role
    getCourseCard(RoleCourseMap[roleParam]),
  ]);

  const {coaches, tags} = coachingData;
  const {allTags: tagMap} = tagsData;

  const cleanedCoaches = cleanCoaches(coaches);

  return {
    props: {
      coaches: cleanedCoaches,
      tags,
      tagMap,
      recommendedCoaches,
      query,
      course,
      courseForRole: (course && roleParam) || null,
      rolePathExists,
    },
  };
}
